// removed by extract-text-webpack-plugin
module.exports = {"ProgressBarHolder":"ProgressBar__ProgressBarHolder__2YOuQ","Point":"ProgressBar__Point__1zZ7U","PointProgressed":"ProgressBar__PointProgressed__YBc-Z","PointFinished":"ProgressBar__PointFinished__3ejdh","Connection":"ProgressBar__Connection__22ETB","ConnectionProgressed":"ProgressBar__ConnectionProgressed__cH5sh","ConnectionFinished":"ProgressBar__ConnectionFinished__3O9pm","Message":"ProgressBar__Message__1ri9s"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/NewRequestSequential/ProgressBar/ProgressBar.css
// module id = 390
// module chunks = 0